define('jquery.1508.imageBuilder',['jquery'],
	function ($) {
		var methods = {
			init: function (options) {
				var selector = $(this).selector;

				this.each(function () {
					var defaults, settings, $this, urlAttr, srcAttr;
					
					$this = $(this);

					settings = $this.data('imageBuilder');

                    if ($this.is('.lazyload, .lazyloading, .lazyloaded')) {
                        return;
                    }

                    if (typeof (settings) === 'undefined') {

						defaults = {
							mobileUrl: '[data-mobileurl]',
							tabletUrl: '[data-tableturl]',
							url: '[data-url]',
							mobileSrc: '[data-mobilesrc]',
							mq: 568,
                            mqTablet: 1024,
							imgWidth: '100%'
						};

                        settings = $.extend({}, defaults, options);
                        $this.data('imageBuilder', settings);
					} else {
						settings = $.extend({}, settings, options);
					}

					//Clean strings
					urlAttr = (settings.mobileUrl).replace('[data-', '').replace(']', '');
					srcAttr = (settings.mobileSrc).replace('[data-', '').replace(']', '');

					//Sanity
					if ($this.data(urlAttr) == undefined && $this.data(srcAttr) != undefined) {
						$this.imageBuilder('imagetag', selector, srcAttr);

                    } else if ($this.data(srcAttr) == undefined && $this.data(urlAttr) != undefined && !$this.hasClass('hero')) {
						$this.imageBuilder('background', selector, urlAttr);
					} else {
						$this.imageBuilder('keepimage', selector);
					}
					
					//RESIZE
					$(window).resize(function () {
						if ($this.data(urlAttr) == undefined && $this.data(srcAttr) != undefined) {
                            $this.imageBuilder('imagetag', selector, srcAttr);
						} else if ($this.data(srcAttr) == undefined && $this.data(urlAttr) != undefined && !$this.hasClass('hero')) {
							$this.imageBuilder('background', selector, urlAttr);
						} else {
							$this.imageBuilder('keepimage', selector);
						}
					});
				});
			},
			imagetag: function (selector, srcAttr) {
				var settings, $this;
				$this = $(this);
				settings = $this.data('imageBuilder');
				if (Modernizr.mq('only screen and (max-width: ' + (settings.mq) + 'px)') && !$this.hasClass('mobileView')) {
					
					if ($this.data(srcAttr)){
						$this.find('.imageBuilder').remove();
						if ($this.data(srcAttr) != 'none' && $this.data(srcAttr).length != 0){
							$this.prepend('<img class="imageBuilder" style=" width:' + (settings.imgWidth) + ';" src="' + $this.data(srcAttr) + '">');
							$this.removeAttr('style');
						}
					}
					//Add control class for resize
					$this.addClass('mobileView');

					
					
				} else if (Modernizr.mq('only screen and (min-width: ' + (settings.mq) +'px)') && $this.hasClass('mobileView')) {
					//Remove control class for resize

					$this.removeClass('mobileView');
					$this.find('.imageBuilder').remove();
					if (selector == '[data-url]') {
						if ($this.css('background-image') == 'none') {
						    $this.css({ 'background-image': 'url(\'' + $this.data('url') + '\')' });
						}
						$this.find('.imageBuilder').remove();
					} else if (selector == '[data-src]' && $this.data('src') > 0) {
						$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
					}
				}else {
					
					if (!$this.hasClass('mobileView')) {
						if (selector == '[data-url]') {
							if ($this.css('background-image') === 'none') {
							    var imageUrl = $this.data('url');
                                if ($this.hasClass('hero') && !$this.hasClass('hero--bg-loading') && !$this.hasClass('hero--bg-loaded')) {
                                    $this.addClass('hero--bg-loading');
                                    $('<img/>').attr('src', imageUrl).on('load', function() {
                                        $(this).remove();
                                        $this.css({'background-image': 'url(' + imageUrl + ')'});
                                        $this.removeClass('hero--bg-loading');
                                        $this.addClass('hero--bg-loaded');
                                    });
                                } else {
                                    $this.css({ 'background-image': 'url(\'' + imageUrl + '\')' });
                                }
							}
							$this.find('.imageBuilder').remove();
						} else if (selector == '[data-src]') {                            
							if ($this.children('.imageBuilder').length<=0 && $this.data('src').length > 0) {    
								$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
							}                           
						}
					}
				}

			},
			background: function (selector, urlAttr) {
				var settings, $this;
				$this = $(this);
				settings = $this.data('imageBuilder');

                if (Modernizr.mq('only screen and (max-width: ' + (settings.mq) +'px)') && !$this.hasClass('mobileView')) {
					$this.css({'background-image': 'url('+ $this.data(urlAttr) +')'});                  
					//Add control class for resize
					$this.addClass('mobileView');
				} else if (Modernizr.mq('only screen and (min-width: ' + (settings.mq) +'px)') && $this.hasClass('mobileView')) {
					//Remove control class for resize
					$this.removeClass('mobileView');
					if (selector == '[data-url]') {
						if ($this.css('background-image') == 'none') {
						    $this.css({ 'background-image': 'url(\'' + $this.data('url') + '\')' });
						}
					} else if (selector == '[data-src]' && $this.data('src').length > 0) {
						$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
					}
				} else {
					if (!$this.hasClass('mobileView')) {
						if (selector === '[data-url]') {
							if ($this.css('background-image') === 'none') {
							    $this.css({ 'background-image': 'url(\'' + $this.data('url') + '\')' });
							}
						} else if (selector === '[data-src]') {
							if ($this.children('.imageBuilder').length <= 0) {
								$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
							}
						}
					}
				}
			},
			keepimage: function(selector) {
				var settings, $this;
				$this = $(this);
                settings = $this.data('imageBuilder');
				if (selector === '[data-url]') {
					if ($this.css('background-image') === 'none') {
                        if ($this.hasClass('hero') && !$this.hasClass('hero--bg-loading') && !$this.hasClass('hero--bg-loaded')) {
                            $this.addClass('hero--bg-loading');
                            var imageUrl = "";
                            if (Modernizr.mq('only screen and (max-width: ' + (settings.mq) + 'px)')) {
                                imageUrl = $this.data('mobileurl');
                            } else if (Modernizr.mq('only screen and (max-width: ' + (settings.mqTablet) + 'px)')) {
                                imageUrl = $this.data('tableturl');
                            } else {
                                imageUrl = $this.data('url');
                            }
                            $('<img/>').attr('src', imageUrl).on('load', function() {
                                $(this).remove();
                                $this.css({'background-image': 'url(' + imageUrl + ')'});
                                $this.removeClass('hero--bg-loading');
                                $this.addClass('hero--bg-loaded');
                            });

                        } else {
                            if (Modernizr.mq('only screen and (max-width: ' + (settings.mq) + 'px)')) {
                                $this.css({'background-image': 'url(' + $this.data('mobileurl') + ')'});
                            } else if (Modernizr.mq('only screen and (max-width: ' + (settings.mqTablet) + 'px)')) {
                                $this.css({'background-image': 'url(' + $this.data('tableturl') + ')'});
                            } else {
                                $this.css({'background-image': 'url(' + $this.data('url') + ')'});
                            }
                        }
					}
					
				} else if (selector === '[data-src]') {
					if ($this.children('.imageBuilder').length <= 0) {
						//Check for mobile
						if (Modernizr.mq('only screen and (max-width: ' + (settings.mq) +'px)')){
							//Check for mobile-src
							if ($this.data('mobilsrc')){
								//check for forced 'none' in mobile-src
								if ($this.data('mobilsrc') !== 'none'){
									//Prepend mobile src
									$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('mobilsrc') + '">');
								}
							}
							else{
								//prepend prepend normel src in mobile view
								if ($this.data('src').length > 0){
									$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
								}
							}
						}
						else{
							if ($this.data('src').length > 0){
								//prepend normal src in normal view
								$this.prepend('<img class="imageBuilder" style=" max-width:' + (settings.imgWidth) + ';" src="' + $this.data('src') + '">');
							}
						}
					}
				}

			}
		};
		$.fn.imageBuilder = function (method) {
			if (methods[method]) {
				return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
			} else if (typeof method === 'object' || !method) {
				return methods.init.apply(this, arguments);
			} else {
				$.error('Method ' + method + ' does not exist in jQuery.imageBuilder');
			}
		};
	});

